<key-options-sidebar class="d-flex" [activeCard]="activeTab" [title]="title" [absolute]="absolute" (onSelected)="handleTabChange($event)" (onHide)="onHide.emit()" [align]="align">
    @if (message) {
        <kui-alert-panel [icon]="message.icon" [message]="message.text">
            @for (button of message?.buttons; track button; let i = $index) {
                <button kui-button size="sm" class="mb-2" [class.ml-1]="i > 0" [color]="button.color" (click)="button.action($event)">
                    {{ button.text }}
                </button>
            }
        </kui-alert-panel>
    }

    @for (tab of customTabs; track tab) {
        <key-options-sidebar-card [icon]="tab.icon" [id]="tab.id" [title]="tab.title">
            <div class="py-3 px-4">
                @if (!!tab?.actions?.length) {
                    <div class="d-flex justify-content-end pb-3 mb-3 border-bottom">
                        @for (action of tab.actions; track action) {
                            <button kui-button size="sm" class="ml-1" [color]="action.color || 'primary'" (click)="action.click()">
                                {{ action.name }}
                            </button>
                        }
                    </div>
                }
                <key-form-builder [form]="tab.form" [values]="tab.values" (onChange)="updateCustomSettings($event)"> </key-form-builder>
            </div>
        </key-options-sidebar-card>
    }

    <!-- TODO: ADD PRESETS -->
    <!-- <key-options-sidebar-card title="'PRESETS" id="presets">
  <div class="py-3 px-4">
    <key-analytics-settings-presets
      *ngIf="presetOptions"
      [options]="presetOptions"
      (onSelected)="updatePresetOptions($event)"
    ></key-analytics-settings-presets>
  </div>
</key-options-sidebar-card> -->
    <key-options-sidebar-card icon="table" [title]="'ANALYTICS.SETTINGS.TABLE' | translate" id="table" [hidden]="!tableSettings">
        @if (tableSettings) {
            <div class="py-3 px-4">
                <key-analytics-settings-table
                    [options]="tableSettings"
                    [show]="{
                        tableLayout: show.tableLayout,
                        levels: show.levels,
                        flipped: show.flipped,
                        measures: show.measures,
                        daterange: show.daterange,
                        calcMeasures: show.calcMeasures,
                    }"
                    [allowCustomDates]="allowCustomDates"
                    [singleMeasureSelection]="singleMeasureSelection"
                    (onExport)="onExport.emit($event)"
                    (onChange)="updateTableSettings($event)"
                ></key-analytics-settings-table>
            </div>
        }
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="chart-line" [title]="'ANALYTICS.SETTINGS.SERIES' | translate" id="series" [hidden]="!seriesSettings">
        @if (seriesSettings) {
            <div class="py-3 px-4">
                <key-analytics-settings-series
                    [options]="seriesSettings"
                    [overriddenValues]="overriddenSeriesValues"
                    (onChange)="updateSeriesSettings($event)"
                    (onClear)="clearOverriddenSeriesValues($event)"
                    (onRemove)="removeMesureFromTable($event)"
                ></key-analytics-settings-series>
            </div>
        }
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="filter" [title]="'ANALYTICS.SETTINGS.FILTERS' | translate" id="filters" [hidden]="hideFilters">
        <div class="py-3 px-4">
            @if (filterSettings) {
                <key-analytics-settings-filters [filters]="filters" [options]="filterSettings" (onChange)="updateFilterSettings($event)"></key-analytics-settings-filters>
            }
        </div>
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="sort-amount-up" [title]="'ANALYTICS.SETTINGS.SORT' | translate" id="sort" [hidden]="!sortSettings">
        @if (sortSettings) {
            <div class="py-3 px-4">
                <key-analytics-settings-sort [options]="sortSettings" (onChange)="updateSortSettings($event)"></key-analytics-settings-sort>
            </div>
        }
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="chart-pie" [title]="'ANALYTICS.SETTINGS.PIE' | translate" id="pie" [hidden]="!pieSettings">
        @if (pieSettings) {
            <div class="py-3 px-4">
                <key-analytics-settings-pie [options]="pieSettings" (onChange)="updatePieSettings($event)"></key-analytics-settings-pie>
                @if (legendSettings) {
                    <key-analytics-settings-legend
                        [title]="'ANALYTICS.SETTINGS.LEGEND' | translate"
                        [options]="legendSettings"
                        (onChange)="updateLegendSettings($event)"
                    ></key-analytics-settings-legend>
                }
            </div>
        }
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="percent" [title]="'ANALYTICS.SETTINGS.STAT' | translate" id="stat" [hidden]="!statSettings">
        @if (statSettings) {
            <div class="py-3 px-4">
                <key-analytics-settings-stat [options]="statSettings" (onChange)="updateStatSettings($event)"></key-analytics-settings-stat>
            </div>
        }
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="chart-bar" [title]="'ANALYTICS.SETTINGS.CHART' | translate" id="chart" [hidden]="!show.chart">
        @if (show.chart) {
            <div class="py-3 px-4">
                @if (chartSettings) {
                    <key-analytics-settings-chart
                        [options]="chartSettings"
                        [show]="{
                            stacked: show.stacked,
                            dataLabels: show.dataLabels,
                        }"
                        (onChange)="updateChartSettings($event)"
                    ></key-analytics-settings-chart>
                }
                @if (yAxisSettings) {
                    <key-analytics-settings-y-axis
                        [options]="yAxisSettings"
                        [show]="{
                            stacked: show.stacked,
                            yAxes: show.yAxes,
                        }"
                        [limits]="yAxesLimits"
                        (onChange)="updateYAxisSettings($event)"
                    ></key-analytics-settings-y-axis>
                }
                @if (xAxisSettings) {
                    <key-analytics-settings-x-axis title="X_AXIS" [options]="xAxisSettings" (onChange)="updateXAxisSettings($event)"></key-analytics-settings-x-axis>
                }
                @if (legendSettings) {
                    <key-analytics-settings-legend title="LEGEND" [options]="legendSettings" (onChange)="updateLegendSettings($event)"></key-analytics-settings-legend>
                }
            </div>
        }
    </key-options-sidebar-card>
    <key-options-sidebar-card icon="info" [title]="'ANALYTICS.SETTINGS.INFO' | translate" id="info" [hidden]="!app.isSystemUser && settings.id">
        <div class="py-3 px-4">
            <key-analytics-settings-info [reportId]="settings.id"></key-analytics-settings-info>
        </div>
    </key-options-sidebar-card>
</key-options-sidebar>
